const StatisticsView = r => require.ensure([], () => r(require('@/page/Statistics/StatisticsView')), 'StatisticsView');
const StatisticsOption = r => require.ensure([], () => r(require('@/page/Statistics/StatisticsOption')), 'StatisticsOption');
const StatisticsList = r => require.ensure([], () => r(require('@/page/Statistics/StatisticsList')), 'StatisticsList');


const statisticsRouter = {
    path: '',
    name: '统计模块',
    component: StatisticsView,
    meta: {
      right: [],
      isShowMenu: true,
      
      icon: 'organMge',
    },
    children: [
      {
        path: '/statisticsOption',
        component: StatisticsOption,
        name: '统计模块',
        meta: {
            right: [],
            keepAlive:false,

        },
    },
      {
        path: '/statisticsList',
        component: StatisticsList,
        name: '查看统计表',
        meta: {
            right: [],
        },
    },
    ]
};
export default statisticsRouter;